<template>
  <div>
    <s-modal
      class="possible-maintenance-modal"
      v-model="showModal"
      size="md"
      no-stacking
      :ok-only="!hasSupervisorPermission"
      :cancel-title="$t('general.no')"
      :ok-title="okTitle"
      @ok="okMethodHandler"
      @cancel="closeModal"
      @shown="getMaintenanceAction"
    >
      <b-row class="m-0">
        <b-col
          class="px-2"
          cols="12"
        >
          {{
            $t('engineering.commutator-maintenance.identified-reduction', {
              commutator: commutatorId,
            })
          }}
        </b-col>
      </b-row>
      <b-row
        v-if="hasSupervisorPermission"
        class="m-0"
      >
        <b-col
          class="px-2 mt-2"
          cols="12"
        >
          <hr/>
          <strong>
            {{ $t('engineering.commutator-maintenance.inform-maintenance-question') }}
          </strong>
        </b-col>
      </b-row>
    </s-modal>
    <maintenance-action-modal
      v-model="showMaintenanceActionModal"
      :maintenance="maintenance"
      @ok="onCloseMaintenanceActionModal"
    />
  </div>
</template>

<script>
import MaintenanceActionModal
  from '@/domain/components/installation/engineering/commutatorMaintenance/modal/MaintenanceActionModal';
import Service from '@/domain/services/installation/engineering/commutatorMaintenance/commutatorMaintenance';

export default {
  name: 'PossibleMaintenanceModal',
  components: { MaintenanceActionModal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    commutatorId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    showMaintenanceActionModal: false,
    maintenance: {},
  }),
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    okMethodHandler() {
      return this.hasSupervisorPermission
        ? this.openMaintenanceActionModal
        : this.closeModal;
    },
    hasSupervisorPermission() {
      return this.$hasUserPermission('PER013');
    },
    okTitle() {
      return this.hasSupervisorPermission
        ? this.$t('general.yes')
        : this.$t('general.ok');
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    openMaintenanceActionModal() {
      this.showMaintenanceActionModal = true;
    },
    onCloseMaintenanceActionModal() {
      this.$emit('refresh-data');
    },
    getMaintenanceAction() {
      const { assetModuleId } = this.$route.params;
      Service.getCommutatorMaintenanceAction(assetModuleId, this.commutatorId)
        .then((response) => {
          this.maintenance = response;
        });
    },
  },
};
</script>
